import { useState } from "react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/solarApi";
import { TextInput, fieldCls } from "@/components/energy/tool";

export default function LeadForm({ type, title, context, defaultMessage = "" }) {
  const [form, setForm] = useState({ name: "", phone: "", whatsapp: "", email: "", location: "", message: defaultMessage, website: "" });
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");

  const set = (k) => (v) => setForm((f) => ({ ...f, [k]: v }));

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await api.post("/energy/leads", { ...form, type, context });
      setDone(true);
      toast.success("Request sent to BNM");
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  if (done) {
    return (
      <div data-testid="lead-success" className="rounded-lg border border-emerald-300 bg-emerald-50 p-6 text-center">
        <p className="font-display text-lg font-bold text-slate-900">Request received</p>
        <p className="mt-2 text-sm text-slate-600">The BNM team will contact you. For faster response, message us on WhatsApp.</p>
      </div>
    );
  }

  return (
    <form onSubmit={submit} data-testid={`lead-form-${type}`} className="rounded-lg border border-slate-200 bg-white p-6 sm:p-8">
      <h3 className="font-display text-lg font-bold text-slate-900">{title}</h3>
      <div className="mt-5 grid grid-cols-1 sm:grid-cols-2 gap-4">
        <TextInput label="Full name" required testid={`lead-name-${type}`} value={form.name} onChange={set("name")} />
        <TextInput label="Phone" required testid={`lead-phone-${type}`} value={form.phone} onChange={set("phone")} type="tel" />
        <TextInput label="WhatsApp" testid={`lead-whatsapp-${type}`} value={form.whatsapp} onChange={set("whatsapp")} type="tel" />
        <TextInput label="Email" testid={`lead-email-${type}`} value={form.email} onChange={set("email")} type="email" />
        <TextInput label="Location / community" testid={`lead-location-${type}`} value={form.location} onChange={set("location")} />
        <label className="block sm:col-span-2">
          <span className="block text-sm font-medium text-slate-700">Message</span>
          <textarea rows={3} value={form.message} data-testid={`lead-message-${type}`} onChange={(e) => set("message")(e.target.value)}
            className="mt-1.5 w-full rounded-md border border-slate-300 bg-white px-3.5 py-2.5 text-sm text-slate-900 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-emerald-600" />
        </label>
        <input type="text" value={form.website} onChange={(e) => set("website")(e.target.value)} className="hidden" tabIndex={-1} autoComplete="off" aria-hidden="true" />
      </div>
      {error && <p role="alert" className="mt-4 text-sm text-red-600">{error}</p>}
      <button type="submit" disabled={busy} data-testid={`lead-submit-${type}`}
        className="mt-5 w-full sm:w-auto rounded-md bg-obsidian px-7 py-3.5 font-semibold text-white transition-[transform,background-color] duration-200 hover:-translate-y-0.5 hover:bg-pine hover:text-volt disabled:opacity-60">
        {busy ? "Sending…" : title}
      </button>
    </form>
  );
}
